/*****
 * 
 * Refatorado em 05/07/2026
 * 
 */

import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { CienciaApiService } from 'app/api/cienciaApi.service';
import { CargoApiService } from 'app/api/cargoApi.service';
import { Ciencia } from 'app/model/ciencia';
import { Fator } from 'app/model/fator';
import { NewPerfil } from 'app/model/newPerfil';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-cargos-search-axiologia',
  templateUrl: './cargos-search-axiologia.component.html',
  styleUrls: ['./cargos-search-axiologia.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // <--- GARANTE FLUIDEZ ISOLANDO AS MUDANÇAS
})
export class CargosSearchAxiologiaComponent implements OnInit, OnDestroy {

  ciencia: Ciencia;
  fatores: Array<Fator>;
  filtroAxiologia: NewPerfil[];
  filtroFatores = [];

  perfisSalvosCargo$: Observable<NewPerfil[]>;
  perfisSalvos: NewPerfil[] = [];
  perfilSalvo: boolean;

  idCiencia = 1; // (1) Axiologia / (2) Comportamento Observado / (3) Motivadores
  nomeCiencia = 'Axiologia';

  order = 'nome';
  reset = false;

  searchText = '';
  selectedCount = 0;

  @Input() idCargo: number;
  @Output() resultadoFiltroAxiologia = new EventEmitter();

  private updateSelectedFatores: Fator[];

  get selectedFatores(): Fator[] {
    return this.updateSelectedFatores;
  }

  @Input()
  set selectedFatores(selectedFatores: Fator[]) {
    this.updateSelectedFatores = selectedFatores;
    if (!selectedFatores) {
      console.error('Nenhum fator foi selecionado!!!');
    }
  }

  private _reloadPerfis: boolean;

  get reloadPerfis(): boolean {
    return this._reloadPerfis;
  }

  @Input()
  set reloadPerfis(reloadPerfis: boolean) {
    this._reloadPerfis = reloadPerfis;
    if (this._reloadPerfis) {
      this.updatePerfisSalvos();
    }
  }

  private subs = new SubSink();

  constructor(
    private cienciaService: CienciaApiService,
    private cargosService: CargoApiService,
    private cdr: ChangeDetectorRef // <--- Injetado para gerenciar o OnPush quando os dados chegam da API
  ) {}

  ngOnInit() {
    if (this.idCargo && this.idCiencia) {
      this.perfisSalvosCargo$ = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, this.idCiencia);
      this.subs.sink = this.perfisSalvosCargo$.subscribe(perfisSalvos => {
        this.perfisSalvos = perfisSalvos;
        if (this.perfisSalvos) {
          this.carregaPerfisSalvos();
        }
      });
    }
    this.getCiencia();
  }

  trackByFator(index: number, item: any): any {
    return item.fatorId || item.id || index;
  }

  getCiencia(): void {
    this.subs.sink = this.cienciaService.v1CienciaCienciaIdGet(this.idCiencia)
    .subscribe(
      ciencia => {
        this.ciencia = ciencia;
        this.cdr.markForCheck(); // Notifica o OnPush que a lista chegou da API
      }, 
      (err) => {
        console.log(err);
      });
  }

  carregaPerfisSalvos() {
    this.perfilSalvo = true;
    
    // Otimizado: Mapeia e ordena em um único fluxo limpo
    this.filtroFatores = this.perfisSalvos.map(perfil => ({
      nome: perfil.fator,
      minimo: perfil.minimo,
      ideal: perfil.ideal,
      maximo: perfil.maximo,
      selected: true 
    })).sort((a, b) => a.nome?.localeCompare(b.nome));

    if (this.filtroFatores.length > 0) {
      this.fatoresSelecionadosSalvos();
    }
    this.cdr.markForCheck();
  }

  updatePerfisSalvos() {
    this.perfisSalvos = [];
    this.subs.sink = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, this.idCiencia)
    .subscribe(perfisSalvos => {
      this.perfisSalvos = perfisSalvos;
      if (this.perfisSalvos) {
        this.carregaPerfisSalvos();
      }
      this.reloadPerfis = false;
      this.cdr.markForCheck();
    });
  }

  fatoresSelecionadosSalvos() {
    this.selectedFatores = this.filtroFatores.filter(fator => fator.selected);
    this.selectedCount = this.selectedFatores.length;

    this.filtroAxiologia = this.selectedCount === 0 ? undefined : this.selectedFatores;
    this.resultadoFiltroAxiologia.emit(this.filtroAxiologia);
  }

  // EVENTO 1 OTIMIZADO: Apenas atualiza a contagem dos selecionados
  fatoresSelecionados() {
    if (!this.ciencia || !this.ciencia.fatores) return;

    this.selectedFatores = this.ciencia.fatores.filter(fator => fator.selected);
    this.selectedCount = this.selectedFatores.length;
    
    if (this.selectedCount === 0) {
      this.filtroAxiologia = undefined;
      this.resultadoFiltroAxiologia.emit(this.filtroAxiologia);
    }
    this.cdr.markForCheck();
  }

  // EVENTO 2 OTIMIZADO: Unificado para rodar de forma linear (O(N)) em vez de loops aninhados
  salvaFiltro() {
    if (!this.ciencia || !this.ciencia.fatores) return;

    const perfis: Array<any> = [];
    const nomesFiltro: string[] = [];

    // Um único loop para extrair o que é necessário de forma limpa
    this.ciencia.fatores.forEach(v => {
      if (v && v.selected === true) {
        perfis.push({ fator: v.nome, minimo: v.minimo, ideal: v.ideal, maximo: v.maximo });
        if (v.nome !== null) {
          nomesFiltro.push(v.nome);
        }
      }
    });

    this.filtroFatores = nomesFiltro.sort((a, b) => a.localeCompare(b));

    if (this.filtroFatores.length > 0) {
      perfis.push({ fator: null, minimo: 60, ideal: 80, maximo: 100 });
    }

    // Ordenação alfabética mais rápida usando localeCompare
    perfis.sort((a, b) => {
      if (!a.fator) return 1;
      if (!b.fator) return -1;
      return a.fator.localeCompare(b.fator);
    });

    this.filtroAxiologia = perfis;
    this.resultadoFiltroAxiologia.emit(this.filtroAxiologia);
    this.cdr.markForCheck();
  }

  deleteFator(id: number, nome?: string) {
    if (!id) {
      this.ciencia.fatores.forEach(fator => {
        if (fator.nome === nome) {
          fator.selected = false;
        }
      });
    } else if (this.selectedFatores?.length > 0) {
      this.selectedFatores.forEach(f => {
        if (f.id === id) {
          f.selected = false;
        }
      });
    }
    this.fatoresSelecionados();
    this.salvaFiltro();
  }

  resetForm() {
    this.reset = true;
    this.resultadoFiltroAxiologia.emit();
    if (this.ciencia && this.ciencia.fatores) {
      this.ciencia.fatores.forEach(f => {
        if (f.id) this.deleteFator(f.id);
      });
    }
    this.cdr.markForCheck();
  }

  recebeSetReset($event) {
    this.reset = $event;
    this.cdr.markForCheck();
  }

  setSearchTerm(term: string) {
    this.searchText = term;
    this.cdr.markForCheck(); // Garante o filtro atualizado com OnPush
  }

  clearFilter() {
    this.searchText = '';
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

/*
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { CienciaApiService } from 'app/api/cienciaApi.service';
import { CargoApiService } from 'app/api/cargoApi.service';
import { Ciencia } from 'app/model/ciencia';
import { Fator } from 'app/model/fator';
import { NewPerfil } from 'app/model/newPerfil';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-cargos-search-axiologia',
  templateUrl: './cargos-search-axiologia.component.html',
  styleUrls: ['./cargos-search-axiologia.component.css']

})
export class CargosSearchAxiologiaComponent implements OnInit, OnDestroy {

  ciencia: Ciencia;
  fatores: Array<Fator>;
  filtroAxiologia: NewPerfil[];
  filtroFatores = [];

  perfisSalvosCargo$: Observable<NewPerfil[]>;
  perfisSalvos: NewPerfil[] = [];
  perfilSalvo: boolean;

  idCiencia = 1; // (1) Axiologia / (2) Axiologia Observado / (3) Motivadores
  nomeCiencia = 'Axiologia';

  order = 'nome';
  reset = false;

  searchText = '';
  selectedCount = 0;

  @Input() idCargo: number;
  @Output() resultadoFiltroAxiologia = new EventEmitter();

  private updateSelectedFatores: Fator[];

  get selectedFatores(): Fator[] {
    return this.updateSelectedFatores;
  }

  @Input()
  set selectedFatores(selectedFatores: Fator[]) {
    this.updateSelectedFatores = selectedFatores;
    if (!selectedFatores) {
      console.error('Nenhum fator foi selecionado!!!');
    }
  }

  private _reloadPerfis: boolean;

  get reloadPerfis(): boolean {
    return this._reloadPerfis;
  }

  @Input()
  set reloadPerfis(reloadPerfis: boolean) {
    this._reloadPerfis = reloadPerfis;
    if (this._reloadPerfis) {
      this.updatePerfisSalvos();
    }
  }

  private subs = new SubSink();

  constructor(
    private cienciaService: CienciaApiService,
    private cargosService: CargoApiService
  ) {}

  ngOnInit() {

    if (this.idCargo && this.idCiencia) {
      this.perfisSalvosCargo$ = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, this.idCiencia);
      this.perfisSalvosCargo$.forEach(perfisSalvos => {
        this.perfisSalvos = perfisSalvos;
        if (this.perfisSalvos) {
          this.carregaPerfisSalvos();
        }
      });
    }

    this.getCiencia();
  }

  trackByFator(index: number, item: any): any {
    // Retorna o ID único do fator (fatorId ou id se for motivador)
    return item.fatorId || item.id || index;
  }

  getCiencia(): void {

    this.subs.sink = this.cienciaService.v1CienciaCienciaIdGet(this.idCiencia)
    .subscribe(
        ciencia => {this.ciencia = ciencia;}, 
        (err) => {
        console.log(err);
      });
  }

  carregaPerfisSalvos() {

    this.perfilSalvo = true;
    this.filtroFatores = [];

    this.perfisSalvos.forEach(perfil => {
      this.filtroFatores.push({
          nome: perfil.fator,
          minimo: perfil.minimo,
          ideal: perfil.ideal,
          maximo: perfil.maximo,
          selected: true 
        });
    });

    this.filtroFatores.sort((a, b) => {
       return a.nome < b.nome ? -1 : a.nome > b.nome ? 1 : 0;
    });

    if (this.filtroFatores.length > 0) {
      this.fatoresSelecionadosSalvos();
    }

  }

  updatePerfisSalvos() {

    this.perfisSalvos = [];

    this.subs.sink = this.cargosService.v1CargoCargoIdCienciaCienciaIdPerfisGet(this.idCargo, this.idCiencia)
    .subscribe(perfisSalvos => {
      this.perfisSalvos = perfisSalvos;
      if (this.perfisSalvos) {
        this.carregaPerfisSalvos();
      }
      this.reloadPerfis = false;
    });

  }

  fatoresSelecionadosSalvos() {

    this.selectedCount = 0;

    if (this.perfilSalvo) {
        this.selectedFatores = this.filtroFatores
        .filter(fator => {
            return (fator.selected);
        });

    }

    this.selectedCount = this.selectedFatores.length;
    if (this.selectedCount === 0) {
      this.filtroAxiologia = undefined;
      this.resultadoFiltroAxiologia.emit(this.filtroAxiologia);
    } else {
      this.filtroAxiologia = this.selectedFatores;
      this.resultadoFiltroAxiologia.emit(this.filtroAxiologia);
    }
  }

  fatoresSelecionados() {

    this.selectedCount = 0;

    this.selectedFatores = this.ciencia.fatores.filter(fator => {
      return (fator.selected);
    });

    this.selectedCount = this.selectedFatores.length;
    
    if (this.selectedCount === 0) {
      this.filtroAxiologia = undefined;
      this.resultadoFiltroAxiologia.emit(this.filtroAxiologia);
    }

  }

  salvaFiltro() {

    this.filtroFatores = [];
    this.filtroFatores = this.ciencia.fatores.filter(v => v.nome !== null && v.selected === true)
      .map((v, i) => v ? v.nome : null);

    this.filtroFatores.sort((a, b) => {
      return a < b ? -1 : a > b ? 1 : 0;
    });

    const perfis: Array<any> = new Array<any>();

    this.ciencia.fatores.filter(v => v.selected === true)
        .map((v, i) => {
          if (v) {
            perfis.push({fator: v.nome, minimo: v.minimo, ideal: v.ideal, maximo: v.maximo});
          }
        });

    if (this.filtroFatores.length > 0) {
      perfis.push({fator: null, minimo: 60, ideal: 80, maximo: 100});
    }

    perfis.sort((a, b) => {
      return a.fator < b.fator ? -1 : a.fator > b.fator ? 1 : 0;
    });

    this.filtroAxiologia = perfis;
    this.resultadoFiltroAxiologia.emit(this.filtroAxiologia); // Envia o resultado do Filtro via Output

  }

  deleteFator(id: number, nome?: string) {
    if (!id) {
      this.selectedFatores = this.ciencia.fatores.filter(fator => {
        if (fator.nome === nome) {
          fator.selected = false;
        }
      });
      this.fatoresSelecionados();
      this.salvaFiltro();
    } else {

    if (this.selectedFatores?.length > 0) {
      this.selectedFatores = this.selectedFatores.filter(f => {
          if (f.id === id) {
              f.selected = false;
      }
          return true;
      });
      this.fatoresSelecionados();
      this.salvaFiltro();
    }

  }
}

  resetForm() {
    this.reset = true;
    this.resultadoFiltroAxiologia.emit();
    this.ciencia.fatores.map(f => {
        this.deleteFator(f.id);
    });
  }

  recebeSetReset($event) {
    this.reset = $event;
  }


  setSearchTerm(term: string) {
    this.searchText = term;
  }

  getSearchTerm() {
      console.log('Pesquisa...');
      return this.searchText;
  }

  clearFilter() {
      this.searchText = '';
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}

*/